/**
 * @generated SignedSource<<cf2a6950a4883d1728c7860ff98504a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackCardItem$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCardFeedback" | "FeedbackCardRequest">;
  readonly " $fragmentType": "FeedbackCardItem";
};
export type FeedbackCardItem$key = {
  readonly " $data"?: FeedbackCardItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCardItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackCardItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeedbackCardFeedback"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeedbackCardRequest"
    }
  ],
  "type": "FeedbackOrRequest",
  "abstractKey": "__isFeedbackOrRequest"
};

(node as any).hash = "266aa93a6209d080c0cd004d85d7d0d9";

export default node;
